import { ArrowText } from './ArrowText';

export type { TypeArrowTextProps } from './types';
export default ArrowText;
